// Sentry JOYBIRD-40-5R8R: WebKit drops in-flight fetches as a page goes away.
export const PAGE_TEARDOWN_ERROR_NAME = 'PageTeardownError';

// Backgrounding kills in-flight requests within a moment of the page hiding;
// a failure later in a hidden tab is a real one and must still be reported.
const HIDDEN_TEARDOWN_WINDOW_MS = 5000;

let isUnloading = false;
let hiddenAt = 0;

const markUnloading = () => {
  isUnloading = true;
};

const syncFromVisibility = () => {
  const isHidden = document.visibilityState === 'hidden';
  if (!isHidden) hiddenAt = 0;
  else if (!hiddenAt) hiddenAt = Date.now();
};

// bfcache restore brings the page back to life, so drop the unloading flag.
const handlePageShow = () => {
  isUnloading = false;
  syncFromVisibility();
};

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  // pagehide, not beforeunload: unreliable on iOS and it blocks bfcache.
  window.addEventListener('pagehide', markUnloading);
  window.addEventListener('pageshow', handlePageShow);
  document.addEventListener('visibilitychange', syncFromVisibility);
  // A page that loaded straight into a hidden tab never fires a transition.
  syncFromVisibility();
}

export const isPageHiddenOrUnloading = () => {
  if (typeof document === 'undefined') return false;
  if (isUnloading) return true;
  if (document.visibilityState !== 'hidden') return false;
  return hiddenAt > 0 && Date.now() - hiddenAt < HIDDEN_TEARDOWN_WINDOW_MS;
};

export class PageTeardownError extends Error {
  constructor(cause) {
    super('Request dropped: the page was unloading or backgrounded', { cause });
    this.name = PAGE_TEARDOWN_ERROR_NAME;
  }
}

// Name check, not instanceof: survives bundle and realm boundaries.
export const isPageTeardownError = err =>
  err?.name === PAGE_TEARDOWN_ERROR_NAME;
